import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux"
import { getFirstSongId, getLastSongId, getPointedRandomAlbum, getRandomModeActive, getRandomRepeatMode, isAlbumFinished } from "../../reducers/randomMode"
import { getCurrentItem, getCurrentItemId } from "../../reducers/playbackState";
import { playPointedRandomAlbum, setFinishedAlbum, setNextRandomAlbumAsPointed, setRandomCurrentTrack } from "../../actions/randomModeActions";
import { RANDOM_REPEAT_MODES } from "../../utils/constants/enumConstants";
import { saveDebugData } from "../../utils/localStorageUtils";

export const useManageRandomMode = () => {   
    const useNewPointedRandomAlbumEffect = () => {
        useEffect(() => {
            if(!randomModeActive || !pointedRandomAlbum)
            {
                return;
            }

            dispatch(playPointedRandomAlbum());
        // eslint-disable-next-line
        }, [randomModeActive, pointedRandomAlbum]);
    }
    
    const useSongChangeEffect = () => {    
        const firstSongId = useSelector(getFirstSongId);
        const lastSongId = useSelector(getLastSongId);
        const finishedAlbum = useSelector(isAlbumFinished);
        const currentItemId = useSelector(getCurrentItemId);
        const currentItem = useSelector(getCurrentItem);
        const repeatMode = useSelector(getRandomRepeatMode);
    
        useEffect(() => {
            if(!randomModeActive || !lastSongId || !currentItemId)
            {
                return;
            }

            dispatch(setRandomCurrentTrack(currentItem));
            saveDebugData(currentItem.name);
    
            // This will be true only if the last song has been the last song of the current album
            if(finishedAlbum)
            {
                // Only if the current song, after the last song of the current album, is the first song of the current album, next random album will be played
                if(firstSongId === currentItemId)
                {
                    // If the random repeat mode is not set to "album" (i.e. the current album hasn't be played in loop), then...
                    if(repeatMode !== RANDOM_REPEAT_MODES.album)
                    {
                        // The next album in queue is set to be played next
                        dispatch(setNextRandomAlbumAsPointed());
                    }
                }
            }
    
            if(lastSongId === currentItemId)
            {
                dispatch(setFinishedAlbum(true));
            }
        // eslint-disable-next-line
        }, [randomModeActive, lastSongId, currentItemId])
    }
    
    const randomModeActive = useSelector(getRandomModeActive);
    const pointedRandomAlbum = useSelector(getPointedRandomAlbum);

    const dispatch = useDispatch();

    useNewPointedRandomAlbumEffect();
    useSongChangeEffect();
}